import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { Authentication, sessionStorageService } from '@web/service';

export const authenticationMatchFn: CanMatchFn = async (route: Route, url: UrlSegment[]) => {
  const authApi = inject(Authentication);
  const router = inject(Router);

  const userState = await authApi.isLoggedIn();

  if (!userState.isLoggedIn) {
    const targetUrl = url.map(segment => segment.path).join('/');
    sessionStorageService.setItem('redirectUrl', targetUrl);
    return router.createUrlTree(['/auth/login']);
  }
  return true;
};
